import React, { useState } from 'react';
import { PlusIcon, SlashIcon, MicIcon, ArrowUpIcon, BriefcaseIcon, UserCheckIcon, UsersIcon, RefreshCwIcon } from 'lucide-react';
import { currentUser } from '../lib/org';
import { openingPrompt } from '../lib/script';
const suggestions = [{
  label: 'Nouveau recrutement',
  icon: BriefcaseIcon,
  fills: true
}, {
  label: "Suivi d'intégration",
  icon: UserCheckIcon
}, {
  label: 'Registre de talents',
  icon: UsersIcon
}, {
  label: 'Apprentissages à valider',
  icon: RefreshCwIcon
}];
const firstName = currentUser.name.split(' ')[0];
type HeroSectionProps = {
  onStart: (text: string) => void;
};
export function HeroSection({
  onStart
}: HeroSectionProps) {
  const [value, setValue] = useState('');
  const start = () => onStart(value.trim() || openingPrompt);
  return <section className="px-5 pb-6 pt-9 sm:px-8 sm:pt-12" data-id="element-161" data-mp="3fibawuuz8l3d">
      <h1 className="text-center font-serif text-3xl font-500 leading-[1.15] tracking-[-0.02em] text-ink sm:text-[40px]" data-id="element-162" data-mp="3fgqfz44r304z">
        Que cherchez-vous, {firstName}&nbsp;?
      </h1>
      <p className="mx-auto mt-3 max-w-[560px] text-center text-[15px] leading-[1.55] text-muted" data-id="element-163" data-mp="2ffs15eyvdauo">
        Décrivez la personne dont vous avez besoin. Talenxia construit le recrutement avec vous.
      </p>

      <div className="mx-auto mt-8 w-full max-w-[760px]" data-id="element-164" data-mp="2p7elq1x3kma3">
        <div className="rounded-[14px] border border-line bg-white p-4 shadow-[0_1px_2px_rgba(10,10,10,0.03)] transition-colors focus-within:border-muted" data-id="element-165" data-mp="2kdk557csgnf8">
          <label htmlFor="job-input" className="sr-only" data-id="element-166" data-mp="2u4esyg5onv2s">
            Décrivez le poste à combler
          </label>
          <textarea id="job-input" rows={2} value={value} onChange={e => setValue(e.target.value)} onKeyDown={e => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            start();
          }
        }} placeholder="Décrivez le résultat que vous voulez obtenir…" className="w-full resize-none bg-transparent px-1 text-[15px] leading-[1.55] text-ink outline-none placeholder:text-muted" data-id="element-167" data-mp="383xnu79hh9x5" />
          <div className="mt-2 flex items-center justify-between" data-id="element-168" data-mp="3dsxxaslup19z">
            <div className="flex items-center gap-1" data-id="element-169" data-mp="3ir97j4g25dsq">
              <button type="button" aria-label="Joindre un fichier" className="flex h-9 w-9 items-center justify-center rounded-full text-muted transition-colors hover:bg-canvas hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2" data-id="element-170" data-mp="3itlobea2xi47">
                <PlusIcon className="h-[18px] w-[18px]" strokeWidth={1.75} data-id="element-171" data-mp="5dnqx8axh9we" />
              </button>
              <button type="button" aria-label="Commandes" className="flex h-9 w-9 items-center justify-center rounded-full text-muted transition-colors hover:bg-canvas hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2" data-id="element-172" data-mp="aanxdkboweo1">
                <SlashIcon className="h-[16px] w-[16px]" strokeWidth={1.75} data-id="element-173" data-mp="1yvbhlo0zleg6" />
              </button>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-174" data-mp="1utgkywu03p8q">
              <button type="button" aria-label="Dicter" className="flex h-9 w-9 items-center justify-center rounded-full text-muted transition-colors hover:bg-canvas hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2" data-id="element-175" data-mp="1uu0065s9nzj2">
                <MicIcon className="h-[18px] w-[18px]" strokeWidth={1.75} data-id="element-176" data-mp="2ds2hrzihiu6u" />
              </button>
              <button type="button" onClick={start} aria-label="Envoyer" className="flex h-9 w-9 items-center justify-center rounded-full bg-ink text-white transition-opacity hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2" data-id="element-177" data-mp="28u12zqs3dh16">
                <ArrowUpIcon className="h-[18px] w-[18px]" strokeWidth={2.25} data-id="element-178" data-mp="2q1qvgkcaqgmp" />
              </button>
            </div>
          </div>
        </div>

        <div className="mt-4 flex flex-wrap justify-center gap-2" data-id="element-179" data-mp="2c30vmwy3e2un">
          {suggestions.map(({
          label,
          icon: Icon,
          fills
        }) => <button key={label} type="button" onClick={() => fills && setValue(openingPrompt)} className="flex items-center gap-2 rounded-full border border-line bg-white px-3.5 py-1.5 text-[13px] text-ink transition-colors hover:border-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-canvas" data-id="element-180" data-mp="2h36ilztf316e">
              <Icon className="h-[15px] w-[15px] text-muted" strokeWidth={1.75} data-id="element-181" data-mp="3np91hnekp4n0" />
              {label}
            </button>)}
        </div>

        <p className="mt-3 text-center text-[12px] text-muted" data-id="element-182" data-mp="3sic0ib24d6al">
          Écrivez ce que vous voulez et appuyez sur Entrée — la séquence se lance.
        </p>
      </div>
    </section>;
}